var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgMaterial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 178,
    viewBox: "0 0 185 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2818_3991",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 125,
    height: 144
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.68777 44.2121L78.8065 87.0432L78.7722 1.43945L4.68777 44.2121Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.56036 71.9985L123.829 142.654L123.772 1.43945L1.56036 71.9985Z",
    stroke: "white"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2818_3991)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -153,
    y: -5,
    width: 245,
    height: 122,
    fill: "#C4C4C4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgMaterial);
export default __webpack_public_path__ + "static/media/bg-material.321c84ec19633f267927f0596f58c895.svg";
export { ForwardRef as ReactComponent };